// extracted by mini-css-extract-plugin
export default {"pic":"CameraPlaceholder_pic__flcgg","outer":"CameraPlaceholder_outer__8+Qef","videoContainer":"CameraPlaceholder_videoContainer__AQzgK"};